import { useMutation, useQueryClient } from '@tanstack/react-query';

import { cancelProject } from '../api/projects.api';
import { invalidateAfterTransition } from '@/shared/lib/invalidate';
import type { Id } from '@/shared/types/domain';

interface CancelVariables {
  projectId: Id;
  ministryId: Id;
  comment: string;
}

/**
 * O evento não vai acontecer (spec-project-review.md §4.4). Autorização é a
 * união de dois predicados no banco — quem escreve no ministério OU quem
 * decide por ele —, então o botão fica fora do painel de decisão, numa área
 * de encerramento que os dois papéis alcançam.
 */
export function useCancelProject() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ projectId, comment }: CancelVariables) => cancelProject(projectId, comment),
    onSuccess: (_data, variables) =>
      invalidateAfterTransition(queryClient, variables.projectId, variables.ministryId),
  });
}
